
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OrderLineModel } from './Entities.GormCrm.OrderLine';
import { ProductModel } from './Entities.GormCrm.Product';
import { ProductVariantsOptionModel } from './Entities.GormCrm.ProductVariantsOption';
import { Model, ModelProperty } from 'models/Model';


export class ProductVariantModel extends Model<ProductVariantModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'name', type: 'string', languageString: 'productVariant.property.name' },
		{ name: 'id', type: 'guid', languageString: 'productVariant.property.id', isHidden: true },
		{ name: 'price', type: 'number', languageString: 'productVariant.property.price' },
		{ name: 'created', type: 'Date', languageString: 'productVariant.property.created', isHidden: true },
		{ name: 'deleted', type: 'Date', languageString: 'productVariant.property.deleted', isHidden: true },
		{ name: 'productId', type: 'guid', languageString: 'productVariant.property.productId' },
		{ name: 'orderLines', type: 'OrderLineModel[]', languageString: 'productVariant.property.orderLines', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } },
		{ name: 'product', type: 'ProductModel', languageString: 'productVariant.property.product', isHidden: true, isObject: true, new: () => { return new ProductModel }, properties: () => { return ProductModel.classProperties } },
		{ name: 'productVariantsOptions', type: 'ProductVariantsOptionModel[]', languageString: 'productVariant.property.productVariantsOptions', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductVariantsOptionModel }, properties: () => { return ProductVariantsOptionModel.classProperties } }
	];
	[key: string]: any;
	
	public name: string;
	public id?: string;
	public price: number;
	public created?: Date;
	public deleted?: Date;
	public productId?: string;
	public orderLines: OrderLineModel[];
	public product?: ProductModel;
	public productVariantsOptions: ProductVariantsOptionModel[];
    
	constructor(){
		super();
		this.name = '';
		this.id = undefined;
		this.price = 0;
		this.created = undefined;
		this.deleted = undefined;
		this.productId = undefined;
		this.orderLines = [];
		this.product = undefined;
		this.productVariantsOptions = [];
		
	}
	getProperties(){
		return ProductVariantModel.classProperties;
	}
}

